// RazzAquatics — Discount Code Script v7
// File: assets/razza-discount.js
//
// v7 fix — cart section re-render after discount apply/remove:
//
// After a successful discount apply or remove, the pill rendered correctly
// but the cart line item prices and subtotal did not update until a full
// page refresh. Root cause: razza-discount.js only updated the pill DOM;
// it never triggered a re-render of the Dawn cart section that owns the
// subtotal and line item price nodes.
//
// FIX: New refreshCartSection() helper fetches /cart?sections=cart-drawer,
// cart-icon-bubble and swaps #CartDrawer-CartItems and .cart-drawer__footer
// innerHTML directly — the same pattern CartDrawerItems uses on qty change.
// Called after successful apply (pollForCode found branch) and after
// successful remove (removeCode poll branch). razzaShippingBar.refresh()
// and razzaDeliveryDate.init() are called inside refreshCartSection() after
// the DOM swap, not before, so they operate on the updated HTML.
//
// Loop safety: refreshCartSection() does not call renderContents(), does not
// dispatch cart:updated, and does not call razzaDiscount.refresh(). The
// footer innerHTML swap triggers onFooterReplaced() via MutationObserver,
// which calls renderTags(_lastDiscounts) — but the v6 DOM-check in
// renderTags() detects the pills are already correct and short-circuits.
// No repaint flash, no infinite loop.
//
// v6 (kept): zero-flash pill rendering via DOM-key check before paintTags().
// v5 (kept): footer childList observer, is-empty observer, onFooterReplaced.

(function () {
  'use strict';

  var tagsEl  = null;
  var input   = null;
  var btn     = null;
  var msgEl   = null;

  var _lastTagsKey   = '';
  var _lastDiscounts = [];
  var _painting      = false;

  function getEls() {
    tagsEl = document.getElementById('razza-disc-tags');
    input  = document.getElementById('razza-disc-input');
    btn    = document.getElementById('razza-disc-btn');
    msgEl  = document.getElementById('razza-disc-msg');
    return !!(tagsEl && input && btn && msgEl);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function setMsg(text, type) {
    msgEl.innerHTML = text;
    msgEl.className = 'razza-disc__msg razza-disc__msg--' + type;
  }

  function clearMsg() {
    msgEl.textContent = '';
    msgEl.className   = 'razza-disc__msg';
  }

  function setBusy(busy) {
    btn.disabled    = busy;
    btn.textContent = busy ? 'Applying...' : 'Apply';
  }

  function getAppliedDiscounts(cart) {
    var seen = {};
    var invalidCodes = {};
    (cart.discount_codes || []).forEach(function (d) {
      if (d.applicable === false) invalidCodes[d.code.toUpperCase()] = true;
    });
    (cart.discount_codes || []).forEach(function (d) {
      if (d.applicable === false) return;
      var key = d.code.toUpperCase();
      if (!seen[key]) seen[key] = { title: d.code, amount: 0, type: 'code' };
      seen[key].amount += (d.amount || 0);
    });
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        var key = d.title.toUpperCase();
        if (invalidCodes[key]) return;
        var isManualCode = (cart.discount_codes || []).some(function (dc) {
          return dc.code.toUpperCase() === key;
        });
        var discType = isManualCode ? 'code' : 'automatic';
        if (!seen[key]) seen[key] = { title: d.title, amount: 0, type: discType };
        seen[key].amount += (d.amount || 0);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      if (d.type !== 'automatic') return;
      var key = d.title.toUpperCase();
      if (!seen[key]) seen[key] = { title: d.title, amount: 0, type: 'automatic' };
      seen[key].amount += (d.total_allocated_amount || 0);
    });
    (cart.items || []).forEach(function (item) {
      (item.discount_allocations || []).forEach(function (alloc) {
        if (!alloc.discount_application) return;
        var app = alloc.discount_application;
        if (app.type !== 'automatic') return;
        var key = app.title.toUpperCase();
        if (!seen[key]) seen[key] = { title: app.title, amount: 0, type: 'automatic' };
        seen[key].amount += (alloc.amount || 0);
      });
    });
    return Object.keys(seen).map(function (k) { return seen[k]; });
  }

  // Key = title+type only (not amount) so qty changes don't force a redraw
  function discountKey(discounts) {
    if (!discounts || !discounts.length) return '';
    return discounts.map(function (d) {
      return d.title.toUpperCase() + ':' + d.type;
    }).sort().join('|');
  }

  // v6: Read the discount key from the CURRENT DOM nodes.
  // Used to detect when Liquid already rendered the correct pill so we
  // can skip paintTags() and avoid the innerHTML clear flash.
  function getDOMDiscountKey() {
    if (!tagsEl) return '';
    var tags = tagsEl.querySelectorAll('.razza-disc__tag');
    if (!tags.length) return '';
    var keys = [];
    tags.forEach(function (tag) {
      var spans = tag.querySelectorAll('span');
      var titleText = '';
      spans.forEach(function (sp) {
        if (!sp.closest('.razza-disc__tag-savings') &&
            !sp.closest('.razza-disc__tag-remove')) {
          titleText = sp.textContent.trim().toUpperCase();
        }
      });
      var removeBtn = tag.querySelector('.razza-disc__tag-remove');
      var type = removeBtn ? 'code' : 'automatic';
      if (titleText) keys.push(titleText + ':' + type);
    });
    return keys.sort().join('|');
  }

  function paintTags(discounts) {
    if (!tagsEl) return;
    _painting = true;
    tagsEl.innerHTML = '';
    if (discounts && discounts.length) {
      discounts.forEach(function (d) {
        var savings = d.amount > 0
          ? '<span class="razza-disc__tag-savings">(-' + money(d.amount) + ')</span>'
          : d.type === 'automatic'
            ? '<span class="razza-disc__tag-savings">Active</span>'
            : '';
        var tag = document.createElement('div');
        tag.className = 'razza-disc__tag';
        tag.innerHTML = [
          '<svg width="11" height="11" viewBox="0 0 16 16" fill="none" style="flex-shrink:0;color:#5CB800">',
            '<path d="M9.5 2L14 6.5a1 1 0 010 1.414L8.414 13.5a1 1 0 01-1.414 0L2.5 9a1 1 0 010-1.414L8.086 2a1 1 0 01.707-.293H8.5A1 1 0 019.5 2z" stroke="currentColor" stroke-width="1.3"/>',
            '<circle cx="5.5" cy="10.5" r="1.2" fill="currentColor"/>',
          '</svg>',
          '<span>' + d.title.toUpperCase() + '</span>',
          savings,
          d.type !== 'automatic' ? [
            '<button class="razza-disc__tag-remove" type="button" data-code="' + d.title + '" aria-label="Remove ' + d.title + '">',
              '<svg width="12" height="12" viewBox="0 0 12 12" fill="none">',
                '<path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>',
              '</svg>',
            '</button>',
          ].join('') : '',
        ].join('');
        tagsEl.appendChild(tag);
      });
    }
    _painting = false;
  }

  function renderTags(discounts) {
    if (!tagsEl) return;
    var newKey = discountKey(discounts);

    // v6: Check what the DOM currently shows before touching anything.
    // If the DOM already has the correct pills (Liquid rendered them or a
    // previous JS paint left them), skip the clear+rebuild to prevent flash.
    if (newKey !== '' && newKey === getDOMDiscountKey()) {
      _lastTagsKey   = newKey;
      _lastDiscounts = discounts ? discounts.slice() : [];
      var currentTags = tagsEl.querySelectorAll('.razza-disc__tag');
      if (currentTags.length === discounts.length) {
        discounts.forEach(function (d, i) {
          var savingsEl = currentTags[i] ? currentTags[i].querySelector('.razza-disc__tag-savings') : null;
          if (savingsEl && d.amount > 0) {
            savingsEl.textContent = '(-' + money(d.amount) + ')';
          }
        });
      }
      return;
    }

    // Same key as cached last state? In-place amount update only.
    if (newKey === _lastTagsKey && newKey !== '') {
      var currentTags = tagsEl.querySelectorAll('.razza-disc__tag');
      if (currentTags.length === discounts.length) {
        discounts.forEach(function (d, i) {
          var savingsEl = currentTags[i] ? currentTags[i].querySelector('.razza-disc__tag-savings') : null;
          if (savingsEl && d.amount > 0) {
            savingsEl.textContent = '(-' + money(d.amount) + ')';
          }
        });
        _lastDiscounts = discounts.slice();
        return;
      }
    }

    // State changed — full repaint.
    _lastTagsKey   = newKey;
    _lastDiscounts = discounts ? discounts.slice() : [];
    paintTags(discounts);
  }

  function refreshFromCart() {
    if (!getEls()) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!getEls()) return;
        renderTags(getAppliedDiscounts(cart));
      })
      .catch(function () {});
  }

  // v7: Re-fetch the cart section HTML and swap line items + footer in place.
  // Called after a successful discount apply or remove so that line item
  // prices and the subtotal reflect the discount without a page refresh.
  // Does NOT call renderContents() (requires pre-fetched sections object),
  // does NOT dispatch cart:updated, does NOT call razzaDiscount.refresh().
  // razzaShippingBar.refresh() and razzaDeliveryDate.init() are called here
  // after the DOM swap so they operate on the updated HTML.
  function refreshCartSection() {
    fetch('/cart?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cart-drawer']) return;
        var parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

        // Swap cart line items
        var cartItemsEl = document.getElementById('CartDrawer-CartItems');
        var newItems    = parsed.querySelector('#CartDrawer-CartItems');
        if (cartItemsEl && newItems) cartItemsEl.innerHTML = newItems.innerHTML;

        // Swap cart footer (subtotal + discount widget area)
        var footerEl  = document.querySelector('.cart-drawer__footer');
        var newFooter = parsed.querySelector('.cart-drawer__footer');
        if (footerEl && newFooter) footerEl.innerHTML = newFooter.innerHTML;

        // Re-init delivery date picker and shipping bar after DOM swap
        if (window.razzaDeliveryDate) window.razzaDeliveryDate.init();
        if (window.razzaShippingBar)  window.razzaShippingBar.refresh();
      })
      .catch(function () {});
  }

  var _refreshTimer = null;
  function scheduleRefresh(delayMs) {
    clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(refreshFromCart, delayMs || 0);
  }

  function clearAllDiscounts() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' }),
    }).then(function (r) { return r.json(); });
  }

  function removeCode(codeToRemove) {
    if (!getEls()) return;
    setBusy(true);
    setMsg('Removing...', 'loading');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var remaining = getAppliedDiscounts(cart)
          .filter(function (d) { return d.title.toUpperCase() !== codeToRemove.toUpperCase(); })
          .map(function (d) { return d.title; });
        return clearAllDiscounts().then(function () { return remaining; });
      })
      .then(function (remaining) {
        return remaining.reduce(function (chain, code) {
          return chain.then(function () {
            return new Promise(function (resolve) {
              var xhr = new XMLHttpRequest();
              xhr.open('GET', '/discount/' + encodeURIComponent(code), true);
              xhr.withCredentials = true;
              xhr.onloadend = resolve;
              xhr.onerror   = resolve;
              xhr.send();
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        var attempts = 0;
        function poll() {
          attempts++;
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var stillThere = getAppliedDiscounts(cart).some(function (d) {
                return d.title.toUpperCase() === codeToRemove.toUpperCase();
              });
              if (!stillThere || attempts >= 6) {
                if (!getEls()) return;
                setBusy(false);
                clearMsg();
                renderTags(getAppliedDiscounts(cart));
                // v7: re-render cart section so prices and subtotal update
                refreshCartSection();
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              } else {
                setTimeout(poll, 500);
              }
            })
            .catch(function () { if (getEls()) { setBusy(false); clearMsg(); refreshFromCart(); } });
        }
        setTimeout(poll, 200);
      })
      .catch(function () {
        if (!getEls()) return;
        setBusy(false);
        setMsg('Something went wrong. Please try again.', 'error');
        refreshFromCart();
      });
  }

  function applyCode(code) {
    setBusy(true);
    setMsg('Applying...', 'loading');
    var xhrDone = false;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/discount/' + encodeURIComponent(code), true);
    xhr.withCredentials = true;
    xhr.onloadend = function () { xhrDone = true; pollForCode(code); };
    xhr.onerror   = function () { setBusy(false); setMsg('Something went wrong. Please try again.', 'error'); };
    xhr.send();
    setTimeout(function () { if (!xhrDone) pollForCode(code); }, 150);
  }

  function pollForCode(code) {
    var attempts  = 0;
    var maxTries  = 8;
    var intervals = [0, 200, 300, 400, 500, 700, 1000, 1500];
    function poll() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var discountEntry = null;
          (cart.discount_codes || []).forEach(function (d) {
            if (d.code.toUpperCase() === code.toUpperCase()) discountEntry = d;
          });
          if (discountEntry && discountEntry.applicable === false) {
            setBusy(false);
            setMsg('<svg style="display:inline;vertical-align:middle;margin-right:4px;flex-shrink:0" width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>Discount code "' + code.toUpperCase() + '" is not valid.', 'error');
            clearAllDiscounts().catch(function () {});
            return;
          }
          var applied = getAppliedDiscounts(cart);
          var found   = applied.some(function (d) { return d.title.toUpperCase() === code.toUpperCase(); });
          if (found) {
            setBusy(false);
            renderTags(applied);
            input.value = '';
            clearMsg();
            // v7: re-render cart section so line item prices and subtotal
            // update immediately without requiring a page refresh.
            // razzaShippingBar.refresh() is called inside refreshCartSection()
            // after the DOM swap — not here — so it operates on updated HTML.
            refreshCartSection();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            return;
          }
          attempts++;
          if (attempts < maxTries) { setTimeout(poll, intervals[attempts] || 1000); return; }
          setBusy(false);
          if (discountEntry) {
            setMsg('<svg style="display:inline;vertical-align:middle;margin-right:4px" width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M8 5v3.5M8 11v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>Code "' + code.toUpperCase() + '" didn\'t apply — minimum order requirements may not be met.', 'error');
            clearAllDiscounts().catch(function () {});
          } else {
            setMsg('<svg style="display:inline;vertical-align:middle;margin-right:4px" width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>Discount code "' + code.toUpperCase() + '" is not valid.', 'error');
          }
        })
        .catch(function () {
          attempts++; if (attempts < maxTries) setTimeout(poll, intervals[attempts] || 1000);
          else { setBusy(false); setMsg('Something went wrong. Please try again.', 'error'); }
        });
    }
    poll();
  }

  document.addEventListener('click', function (e) {
    if (!e.target) return;
    var isApplyBtn = e.target.id === 'razza-disc-btn' || (e.target.closest && !!e.target.closest('#razza-disc-btn'));
    if (isApplyBtn) {
      if (!getEls()) { console.warn('[RazzaDiscount] Elements missing on click'); return; }
      var code = input.value.trim();
      if (!code) { setMsg('Please enter a discount code.', 'error'); return; }
      applyCode(code); return;
    }
    var removeBtn = e.target.closest && e.target.closest('.razza-disc__tag-remove');
    if (removeBtn) {
      var codeToRemove = removeBtn.dataset.code;
      if (codeToRemove) removeCode(codeToRemove); return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target || e.target.id !== 'razza-disc-input') return;
    if (!getEls()) return;
    var code = input.value.trim();
    if (!code) { setMsg('Please enter a discount code.', 'error'); return; }
    applyCode(code);
  });

  document.addEventListener('input', function (e) {
    if (!e.target || e.target.id !== 'razza-disc-input') return;
    if (!getEls()) return;
    clearMsg();
  });

  // ── Init ──────────────────────────────────────────────────────────────
  refreshFromCart();

  ['cart:updated', 'theme:cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleRefresh(0); });
  });

  // ── Footer childList observer (v5) ──────────────────────────────────
  // Watches .cart-drawer__footer for childList changes (Dawn qty-update).
  // When it fires, repaint from cache then schedule a background verify.
  function onFooterReplaced() {
    if (_painting) return;
    if (!_lastDiscounts.length) return;
    var freshTagsEl = document.getElementById('razza-disc-tags');
    if (!freshTagsEl) return;
    tagsEl = freshTagsEl;
    // v6: use renderTags (not paintTags) so the DOM-check logic runs first.
    renderTags(_lastDiscounts);
    scheduleRefresh(50);
  }

  function attachFooterObserver() {
    var footer = document.querySelector('.cart-drawer__footer');
    if (!footer || footer._razzaFooterObserved) return;
    footer._razzaFooterObserved = true;
    new MutationObserver(function (mutations) {
      var hasRemoval = mutations.some(function (m) { return m.removedNodes.length > 0; });
      if (hasRemoval) onFooterReplaced();
    }).observe(footer, { childList: true });
  }

  attachFooterObserver();

  new MutationObserver(function () {
    var footer = document.querySelector('.cart-drawer__footer');
    if (footer && !footer._razzaFooterObserved) attachFooterObserver();
  }).observe(document.body, { childList: true, subtree: true });

  // ── cart-drawer is-empty observer ─────────────────────────────────
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    var _wasEmpty = cartDrawerEl.classList.contains('is-empty');
    new MutationObserver(function () {
      var isEmpty = cartDrawerEl.classList.contains('is-empty');
      if (isEmpty && !_wasEmpty) {
        if (getEls()) { tagsEl.innerHTML = ''; }
        _lastTagsKey   = '';
        _lastDiscounts = [];
      }
      if (!isEmpty && _wasEmpty) { scheduleRefresh(0); }
      _wasEmpty = isEmpty;
    }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
  }

  window.razzaDiscount = { refresh: refreshFromCart };

})();